import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextBuildingBlock } from '@work4all/models/lib/Classes/TextBuildingBlock.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { OrganisationArea } from '../../organisation-area';
import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/textBuildingBlock-table-schema.json';
import { TableAreas } from '../table/Table';

const defaultSort = [{ field: 'name', direction: SortDirection.DESCENDING }];

export function TextBuildingBlockTable(props: IEntityTableV8) {
  const { t } = useTranslation();

  const dataTable = useEntityDataTableV8<
    TextBuildingBlock,
    Record<string, never>
  >({
    ...props,
    schema: schema as never,
    defaultSort,
  });

  const areas = useMemo<TableAreas>(() => {
    return {
      left: {
        title: t('COMMON.ORGANISATION'),
        content: (
          <OrganisationArea
            table={dataTable.table}
            entity={Entities.textBuildingBlock}
          />
        ),
        resizable: true,
        collapsible: true,
        custom: true,
      },
    };
  }, [dataTable.table, t]);

  return <EntityTableV8 {...props} {...dataTable} areas={areas} />;
}
